module.exports = __webpack_public_path__ + "img/pay_weixin.29001c94.png";